import { AuthContext } from "@redotech/redo-merchant-app-common/auth";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import type { SupportTicketQueryScope } from "@redotech/redo-support-v2/query/support-ticket-query-keys";
import { useContext, useMemo } from "react";

export function useSupportTicketQueryScope(): SupportTicketQueryScope {
  const auth = useContext(AuthContext);
  const team = useContext(TeamContext);

  return useMemo(
    () => ({
      accountId: team?.accountId ?? null,
      teamId: auth?.teamId ?? team?._id ?? null,
    }),
    [auth?.teamId, team?._id, team?.accountId],
  );
}
